import { render, staticRenderFns } from "./LastTicketsDetailsBody.vue?vue&type=template&id=3c595f2c&scoped=true"
import script from "./LastTicketsDetailsBody.vue?vue&type=script&lang=js"
export * from "./LastTicketsDetailsBody.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsDetailsBody.vue?vue&type=style&index=0&id=3c595f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c595f2c",
  null
  
)

export default component.exports